/* tslint:disable */
import React, { Component, ReactNode } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import cx from "classnames";
import _ from 'lodash'
import { styles } from "../utils/styles";
import {
  MenuItemEventHandler,
  TriggerEvent,
  StyleProps,
  InternalProps
} from "../types";

export interface ItemProps extends StyleProps, InternalProps {
  /**
   * @description
   */
  shortcutKey: string;
  /**
   * @description Any valid node that can be rendered
   */
  children: ReactNode;
  /**
   * @description Passed to the `Item` onClick callback. Accessible via `props`
   */
  data?: object;

  /**
   * Disable or not the `Item`. If a function is used, a boolean must be returned
   */
  disabled: boolean | ((args: MenuItemEventHandler) => boolean);

  /**
   * Callback when the current `Item` is clicked. The callback give you access to the current event and also the data passed
   * to the `Item`.
   * `({ event, props }) => ...`
   */
  onClick: (args: MenuItemEventHandler) => any;
}

const noop = () => {};

class Item extends Component<ItemProps> {
  static propTypes = {
    shortcutKey: PropTypes.string,
    children: PropTypes.node.isRequired,
    data: PropTypes.object,
    disabled: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    onClick: PropTypes.func,
    nativeEvent: PropTypes.object,
    propsFromTrigger: PropTypes.object,
    className: PropTypes.string,
    style: PropTypes.object
  };

  static defaultProps = {
    shortcutKey: "",
    disabled: false,
    onClick: noop
  };

  isDisabled: boolean;

  constructor(props: ItemProps) {
    super(props);
    const { disabled, nativeEvent, propsFromTrigger, data } = this.props;

    this.isDisabled =
      typeof disabled === "function"
        ? disabled({
            event: nativeEvent as TriggerEvent,
            props: { ...propsFromTrigger, ...data }
          })
        : disabled;
  }

  /**
   * @method close
   * @description 이 LayoutChooser UI Component를 닫기
   * @memberof LayoutChooser
   */
  close() {
    const domNode : any = ReactDOM.findDOMNode(this);
    let node : any = null
    if (_.get(domNode, ".parentElement")){
      node = domNode.parentElement
    }
    if (_.get(node, ".parentElement")){
      node = node.parentElement
    }
    ReactDOM.unmountComponentAtNode(node);
  }

  handleClick = (e: React.MouseEvent) => {
    this.isDisabled
      ? e.stopPropagation()
      : this.props.onClick({
          event: this.props.nativeEvent as TriggerEvent,
          props: { ...this.props.propsFromTrigger, ...this.props.data }
        });
    this.close();
  };

  render() {
    const { className, style, children, shortcutKey } = this.props;

    const cssClasses = cx(styles.item, className, {
      [`${styles.itemDisabled}`]: this.isDisabled
    });

    return (
      <div
        className={cssClasses}
        style={style}
        onClick={this.handleClick}
        role="presentation"
      >
        <div className={styles.leftAlign}>
          <div className={styles.itemContent}>{children}</div>
        </div>
        <div className={styles.rightAlign}>
          <div className={styles.itemShortcutKey}>{shortcutKey}</div>
        </div>
      </div>
    );
  }
}

export { Item };
